(() => {
  const enhance = () => {
    document.querySelectorAll('.homes__article #main-content .rte table').forEach(table => {
      if (table.dataset.mbxTableReady) return;
      table.dataset.mbxTableReady = 'true';
      const mediaLayout = !table.querySelector('th,thead') && !!table.querySelector('img,iframe,video');
      table.classList.add(mediaLayout ? 'mbx-media-table' : 'mbx-data-table');
      const rows = Array.from(table.querySelectorAll('tr')).filter(row => row.closest('table') === table);
      const columns = Math.max(1, ...rows.map(row => Array.from(row.children).reduce((n, cell) => n + (Number(cell.getAttribute('colspan')) || 1), 0)));
      table.style.setProperty('--mbx-table-min', Math.max(480, columns * 160) + 'px');
      if (!mediaLayout && !table.querySelector('thead')) {
        const first = rows[0];
        if (first && Array.from(first.children).every(cell => cell.tagName === 'TH' || (cell.querySelector('strong,b') && cell.textContent.trim() === cell.querySelector('strong,b').textContent.trim()))) first.classList.add('mbx-table-header');
      }
      let wrapper = table.parentElement;
      if (!wrapper.matches('.scrollable-table,.table-wrap,.mbx-table-scroll')) {
        wrapper = document.createElement('div');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
      wrapper.classList.add('mbx-table-scroll');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('role', 'region');
      const caption = table.querySelector('caption');
      const heading = table.closest('.tool,section')?.querySelector('h2,h3') || document.querySelector('.mbx-article__header h1');
      wrapper.setAttribute('aria-label', (caption || heading)?.textContent.trim() || document.title);
      for (let ancestor = wrapper.parentElement; ancestor && !ancestor.matches('.rte'); ancestor = ancestor.parentElement) ancestor.classList.add('mbx-table-container');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
